// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2M-1I","assignButton":"CreateEditEquipmentSchedule_assignButton__1_vLd"};